import { useState, useEffect } from 'react';

/**
 * Reusable session storage state hook
 * @param {string} key - A unique key namespace
 * @param {string | number} id - Unique identifier for item (e.g. assignedId)
 * @param {*} defaultValue - Default state value
 * @returns {[any, Function]} state value and setter
 */
function useSessionState(key, id, defaultValue) {
  const storageKey = `${key}-${id}`;
  const [value, setValue] = useState(() => {
    try {
      const stored = sessionStorage.getItem(storageKey);
      if (stored) {
        return JSON.parse(stored);
      }
      sessionStorage.setItem(storageKey, JSON.stringify(defaultValue));
      return defaultValue;
    } catch (error) {
      console.warn(`[useSessionState] Error with ${storageKey}`, error);
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {
      console.warn(`[useSessionState] Failed to store ${storageKey}`, error);
    }
  }, [storageKey, value]);

  return [value, setValue];
}

export default useSessionState;
